import { Component, ChangeDetectionStrategy } from "@angular/core";
import { MenuPortaleComponent } from "../../components/menu-portale.component";
import { ClassForScreenDirective } from "../../../../lib/directives/class-for-screen.directive";
import { LoginPortaleComponent } from "../../components/login-portale.component";
import { ScaricaAppComponent } from "../../components/scarica-app.component";
import { PortaleLayoutFooterComponent } from "../../../layout/portale-layout-footer/portale-layout-footer.component";

@Component({
    selector: 'login-page',
    templateUrl: './login-page.component.html',
    styleUrls: ['../../../../lib/themes/portale.theme.scss'],
    changeDetection: ChangeDetectionStrategy.Eager,
    imports: [MenuPortaleComponent, ClassForScreenDirective, LoginPortaleComponent, ScaricaAppComponent, PortaleLayoutFooterComponent]
})
export class LoginPageComponent {

}